<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">매체소개 관리</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">
        <el-row :gutter="10">
          <el-col :span="12" class="text-info">* 활성체크된 이미지/PDF가 매체소개 페이지에 노출됩니다.</el-col>
          <el-col :span="12" class="text-right">

            <el-upload
                    class="dp-inblock"
                    ref="mediaInfo"
                    action="/api/settings/info/main-media/upload"
                    accept=".pdf,image/*"
                    :headers="header"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :auto-upload="true">
                    <el-button slot="trigger" size="small" type="primary" >이미지/PDF 추가</el-button>
            </el-upload>
          </el-col>
        </el-row>

      <el-row :gutter="10">
      <el-col :span="24" class="mt-2">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="items"
                  :header-cell-style="tableRowStyle">

          <el-table-column
            width="80"
            label="종류">
            <template slot-scope="{row}">
              <span v-if="row.type === 'image'">이미지</span>
              <span v-if="row.type === 'pdf'">PDF</span>
            </template>
          </el-table-column>

          <el-table-column
            width="120"
            align="center"
            label="활성">
            <template slot-scope="{row}">
              <el-switch v-model="row.active" @change="activeChange(row)"></el-switch>
            </template>
          </el-table-column>


          <!-- <el-table-column
            prop="src"
            label="경로">
          </el-table-column> -->
                  
          <el-table-column
          align="center"
            label="미리보기">
            <template slot-scope="{row}">
              <img v-if="row.type === 'image'" :src="row.src" style="height: 120px;"/>
              <span v-if="row.type === 'pdf'">
                {{ row.filename }}
              </span>              
            </template>
          </el-table-column>

          <el-table-column
            width="80"
            align="center"
            label="">
            <template slot-scope="props">
              <el-button size="mini" title="삭제" type="danger" icon="el-icon-delete-solid" @click="remove(props.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      </el-row>


      </div>
      <div class="modal-footer">
            <el-button @click="$emit('dismiss')">닫 기</el-button>
      </div>
    </div>

</template>

<script>

import MainMediaProxy from '@/proxies/MainMediaProxy';
import { time } from 'd3';

export default {
    created() {
        this.getList()
    },
    props: {
        handler: {
            type: Function
        }
    },
    data() {
      return {
        items: [],
        delay: 6,
        header: {
          Authorization:$cookies.get('id_token')
        }

      }
    },    
    methods: {
        uploadSuccess(response, files, fileList) {
          if (response.header.returnCode === "OK") {
            this.$refs["mediaInfo"].clearFiles();
            this.getList();
            alert("저장되었습니다.");
          } else {
            alert(response.header.resultMessages);
          }
        },
        tableRowStyle() {
            return this.$store.state.common.tableHeaderCellStyle;
        },
        activeChange(row) {

          this.items.forEach(item=> {
            if(row !== item) {
              item.active = false;
            }
          })
          new MainMediaProxy().saveList( this.items )

        },
        remove( id ) {
          if(confirm('삭제 하시겠습니까?')) {

            const index = this.items.findIndex(function(item) {
                return item.id === id;
            });

            if (index !== -1) {
                this.items.splice(index, 1);

                new MainMediaProxy()
                .saveList( this.items )

            }            

          }  
        },

        getList() {

          return new MainMediaProxy()
          .all()
          .then((response) => {
            this.items = [...response.item.items];
            this.delay = response.item.delay;
            return response.item;
          })          

            
        }
    },

}
</script>